export const SAMPLE_TYPES = [
  "whole_blood",
  "serum",
  "feces",
  "tick_and_other_ectoparasites",
  "euthanized_animal",
  "organs",
  "other",
] as const;

export const SAMPLE_TYPE_COLORS: Record<
  SampleType,
  { hex: string; tw: string }
> = {
  whole_blood: { hex: "#DC2626", tw: "bg-red-600" },
  serum: { hex: "#2563EB", tw: "bg-blue-600" },
  feces: { hex: "#B45309", tw: "bg-yellow-700" },
  tick_and_other_ectoparasites: {
    hex: "#065F46",
    tw: "bg-green-700",
  },
  euthanized_animal: { hex: "#6B7280", tw: "bg-gray-500" },
  organs: { hex: "#7C3AED", tw: "bg-purple-600" },
  other: { hex: "#475569", tw: "bg-slate-500" },
};

export type SampleType = (typeof SAMPLE_TYPES)[number];

export const SAMPLE_TYPE_LABELS: Record<SampleType, string> = {
  whole_blood: "Sangue Total",
  serum: "Soro",
  feces: "Fezes",
  tick_and_other_ectoparasites: "Carrapatos e outros ectoparasitas",
  euthanized_animal: "Animal Eutanasiado",
  organs: "Órgãos",
  other: "Outros",
};

export const SAMPLE_TYPE_OPTIONS = Object.entries(SAMPLE_TYPE_LABELS).map(
  ([value, label]) => ({ value: value as SampleType, label }),
);

export function getTypeLabel(type: SampleType): string {
  return SAMPLE_TYPE_LABELS[type] ?? type;
}
